import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {TranslationService} from '../../../../../../modules/i18n';
import {ApiService} from "../../../../../../services/api.service";
import {NzModalService} from "ng-zorro-antd/modal";
import {UserService} from "../../../../../../services/user.service";
import {CookieService} from "ngx-cookie-service";
import {AuthService} from "@auth0/auth0-angular";
import {
  ConfirmationModalComponent
} from "../../../../../../modules/shared/dialogs/confirmation-modal/confirmation-modal.component";
import {TenantService} from "../../../../../../services/tenant.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-user-inner',
  templateUrl: './user-inner.component.html',
})
export class UserInnerComponent implements OnInit, OnDestroy {
  @HostBinding('class')
  class = `menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-225px`;
  @HostBinding('attr.data-kt-menu') dataKtMenu = 'true';

  language: LanguageFlag;
  user$: Observable<any>;
  langs = languages;

  private unsubscribe: Subscription[] = [];

  constructor(
    private userService: UserService,
    private translationService: TranslationService,
    public api: ApiService,
    public modal: NzModalService,
    private cookieService: CookieService,
    private tenantService: TenantService,
    private router: Router,
    private auth: AuthService
  ) {}

  ngOnInit(): void {
    this.user$ = this.userService.currentUserSubject;
    this.setLanguage(this.translationService.getSelectedLanguage());
  }

  get canChangePassword(){
    return this.userService.currentUserValue.user_id.includes('auth0');
  }

  logout() {
    this.cookieService.deleteAll('/')
    this.auth.logout();
  }

  selectLanguage(lang: string) {
    this.translationService.setLanguage(lang);
    this.setLanguage(lang);
    // document.location.reload();
  }

  setLanguage(lang: string) {
    this.langs.forEach((language: LanguageFlag) => {
      if (language.lang === lang) {
        language.active = true;
        this.language = language;
      } else {
        language.active = false;
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  switchAccount(){
    this.tenantService.cookie.delete('qrpay_tenant', '/');
    location.reload();
  }

  passwordModal(){

    this.modal.create({
      nzTitle: 'Reset Password?',
      nzContent: ConfirmationModalComponent,
      nzComponentParams: {
        confirmationMessage: 'We will send a password reset link to your e-mail.',
        actionURL: 'user/password',
        actionMethod: 'Post'
      }
    });
  }

}

interface LanguageFlag {
  lang: string;
  name: string;
  flag: string;
  active?: boolean;
}

const languages = [
  {
    lang: 'en',
    name: 'English',
    flag: './assets/media/flags/united-states.svg',
  },
  {
    lang: 'zh',
    name: 'Mandarin',
    flag: './assets/media/flags/china.svg',
  },
  {
    lang: 'es',
    name: 'Spanish',
    flag: './assets/media/flags/spain.svg',
  },
  {
    lang: 'ja',
    name: 'Japanese',
    flag: './assets/media/flags/japan.svg',
  },
  {
    lang: 'de',
    name: 'German',
    flag: './assets/media/flags/germany.svg',
  },
  {
    lang: 'fr',
    name: 'French',
    flag: './assets/media/flags/france.svg',
  },
];
